import { ArrowDown, ArrowRight } from './icons'
import { Reveal } from '../hooks/useReveal'

export const Header = ({ profile }) => {
  const [first, ...rest] = profile.name.split(' ')

  return (
    <header className="hero" id="top">
      <div className="container hero__grid">
        <Reveal>
          <p className="status">
            <span className="status__dot" aria-hidden="true" />
            {profile.status}
          </p>

          <h1 className="hero__name">
            {first} <em>{rest.join(' ')}</em>
          </h1>

          <p className="hero__role">
            {profile.role}
            <span className="hero__spec">
              {profile.specialisms.map((s) => (
                <span key={s}>{s}</span>
              ))}
            </span>
          </p>

          <p className="hero__headline">{profile.headline}</p>

          <div className="hero__actions">
            <a className="btn btn--primary" href="#work">
              See the work
              <ArrowDown className="btn__arrow" />
            </a>
            <a className="btn btn--ghost" href="#contact">
              Get in touch
              <ArrowRight className="btn__arrow" />
            </a>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="panel">
            <div className="panel__bar">
              <span className="panel__dots" aria-hidden="true">
                <i />
                <i />
                <i />
              </span>
              profile
            </div>

            <dl className="panel__body">
              {profile.meta.map((item) => (
                <div className="meta-row" key={item.label}>
                  <dt>{item.label}</dt>
                  <dd>{item.value}</dd>
                </div>
              ))}
            </dl>

            <div className="panel__foot">
              <p className="panel__label">Top skills</p>
              <ul className="top-skills">
                {profile.topSkills.map((skill) => (
                  <li className="top-skill" key={skill}>
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </header>
  )
}
